import React, { FC, useState } from "react";
import { Create, CreateProps, FormTab, TabbedForm } from "react-admin";
import { CreditProps } from "../common/generalPickersBlocks/credits/CreditsPickerComponent";
import DiscountAndTickets from "../common/discount/DiscountTickets";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import PrizeGeneralForm from "../lifestylePrizes/PrizeGeneralForm";
import FixedOddsToolbar from "./FixedOddsToolbar";

const FixedOddsCreate: FC<CreateProps> = (props) => {
  const [datesValue, setDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date("2031-01-18T19:55:00.000+00:00"),
  });

  const [countdownDatesValue, setCountdownDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date("2031-01-18T19:55:00.000+00:00"),
  });

  const [creditDateType, setCreditDateType] = useState<string>("allDate");

  const handleChangeCreditsDateType = (e: any) => {
    setCreditDateType(e.currentTarget.value);
  };

  const setCountdown = (name: string, value: string) => {
    setCountdownDatesValue({ ...countdownDatesValue, [name]: value });
  };
  const [stateCredits, setCredits] = useState<Array<CreditProps>>([
    {
      id: "1",
      count: 20,
      percent: 30,
    },
  ]);

  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };
  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };
  const handleSetDateValue = (value: string, dateName: string) => {
    setDatesValue({
      ...datesValue,
      [dateName]: value,
    });
  };

  const [state, setState] = useState({
    isCash: false,
    isPercent: false,
  });

  const [errors, setError] = useState({
    imagesError: false,
    discountFillError: false,
    countdownError: false,
  });

  const [isDiscountValidate, setIsDiscountValidate] = useState(false);

  const handleDiscountFillError = (error: boolean) => {
    setError({ ...errors, discountFillError: error });
  };

  const handleSetCountdownError = (error: boolean) => {
    setError({ ...errors, countdownError: error });
  };

  const handleImagesError = (error: boolean) => {
    setError({ ...errors, imagesError: error });
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setState({ ...state, [event.currentTarget.name]: checked });
  };

  const setPercent = () => {
    setState({ ...state, isPercent: false });
  };

  const setCash = () => {
    setState({ ...state, isCash: false });
  };

  return (
    <>
      <DocumentTitle
        core="Prize"
        secondary="Fixed Odds"
        purpose="Add new"
        appointment="Fixed Odd"
      />
      <Create {...props}>
        <TabbedForm
          className="general-tab"
          toolbar={FixedOddsToolbar(
            props,
            true,
            handleImagesError,
            handleDiscountFillError,
            setIsDiscountValidate,
            handleSetCountdownError,
            {
              creditsArr: stateCredits,
              dateType: creditDateType,
              creditsStartDate: datesValue.startDateValue,
              creditsEndDate: datesValue.endDateValue,
              creditsStatus: isActiveCredits,
            },
            countdownDatesValue.startDateValue,
            countdownDatesValue.endDateValue,
            undefined
          )}
        >
          <FormTab label="General">
            <PrizeGeneralForm
              record={undefined}
              isShow={false}
              isPrize={false}
              setCountdown={setCountdown}
              imagesError={errors.imagesError}
              countdownError={errors.countdownError}
              countdownStartDate={countdownDatesValue.startDateValue}
              countdownEndDate={countdownDatesValue.endDateValue}
            />
          </FormTab>
          <FormTab label="Discount & tickets">
            <DiscountAndTickets
              entity={undefined}
              isShow={false}
              ticketPrice={0}
              discountSource="discountCategory"
              isCash={state.isCash}
              isPercent={state.isPercent}
              handleChange={handleChange}
              removePercent={setPercent}
              removeCash={setCash}
              discountFillError={errors.discountFillError}
              isOdds={true}
              isValidate={isDiscountValidate}
              handleChangeCreditsStatus={handleChangeCreditsStatus}
              handleChangeCreditsDateType={handleChangeCreditsDateType}
              handleSetCredits={handleSetCredits}
              isActiveCredits={isActiveCredits}
              credits={stateCredits}
              handleSetDateValue={handleSetDateValue}
              creditDateType={creditDateType}
              creditsStartDateValue={datesValue.startDateValue}
              creditsEndDateValue={datesValue.endDateValue}
              competition="fixedOdds"
            />
          </FormTab>
        </TabbedForm>
      </Create>
    </>
  );
};

export default FixedOddsCreate;
